export default "__VITE_ASSET__CUhS1pn0__"